import type { AllExperiments } from '@growthBookExperimentation/Entities/Experiments.entities';
import type { FlagKey } from '@growthBookExperimentation/Entities/FlagKeys.entities';

import type { ExperimentViewedEvent } from '../Schemas/ExperimentViewed/ExperimentViewedEvent';
import { experimentViewedToEvent } from '../Schemas/ExperimentViewed/ExperimentViewedToEvent';

export const getExperimentViewedEvents = (
  ids: FlagKey[],
  experiments: AllExperiments | undefined,
): ExperimentViewedEvent[] => {
  return ids.reduce<ExperimentViewedEvent[]>((events, id) => {
    const experiment = experiments?.find(exp => exp?.experimentId === id);
    if (experiment) {
      events.push(
        experimentViewedToEvent({
          experimentId: id,
          variationId: experiment?.variationId,
        }),
      );
    }
    return events;
  }, []);
};
